import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { neutralDark40, toRgba } from "../../../constants/colors";
import { sizes } from "../../../constants/spacing";
var darkSeparatorColor = toRgba(neutralDark40, 0.12);
export var StyledModalActionSeparator = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    width: 2px;\n    height: ", "px;\n"])), darkSeparatorColor, sizes.large);
//# sourceMappingURL=ActionSeparator.js.map